<ng-template #manageEsimModalForm role="document" let-modal>
  <app-modal-comp-header
    [button0Danger]="true"
    [button0Show]="showRiskButton"
    [button0Text]="'Riskline'"
    [fileLockHoverText]="fileLockHoverText"
    [showFileLockIcon]="formIsLocked"
    [title]="formTitle"
    (button0Click)="openRiskTripReady()"
    (cancelButtonOnClick)="eSimManagerFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="eSimManagerFormSubmit()" [formGroup]="eSimManagerForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body" ngbAutofocus tabindex="-1">
      <ul ngbNav #ArrowNgbNav="ngbNav" [(activeId)]="activeId" (navChange)="beforeTabChange($event)" (shown)="onTabChange($event)" class="nav nav-pills arrow-navtabs nav-success bg-light mb-3">
        <li [ngbNavItem]="navItemSimDetails">
          <a ngbNavLink>
            @if(showOrderTabIcons) {
              <span class="d-block"><i class="ri-sim-card-line"></i></span>
            }
            <span class="d-sm-block">SIM Details</span>
          </a>
          <ng-template ngbNavContent>
            <div formGroupName="orderDetailsForm">
              @if(newOrder){
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                      <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                      <span [innerHtml]="progressInformation"></span>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div class="row">
                <div class="col-6">

                  <div class="border border-success rounded h-100">
                    <div class="row">
                       <div class="col-12">
                         <div>
                           <div class="alert border-0 alert-primary" role="alert">
                             <strong>Order Details</strong>
                           </div>
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="orderNo-field" class="form-label">Order No</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="orderNo-field" class="form-control text-end border-0" placeholder="" formControlName="orderNo" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['orderNo'].errors }" />
                          @if(formOfOrderDetails['orderNo'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{orderNoMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="supplierOrderNo-field" class="form-label">Supplier Order</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="supplierOrderNo-field" class="form-control text-end border-0" placeholder="" formControlName="supplierOrderNo" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['supplierOrderNo'].errors }" />
                          @if(formOfOrderDetails['supplierOrderNo'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{supplierOrderNoMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                         </div>
                       </div>
                     </div>

                     <div class="row" hidden="true">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="companyId-field" class="form-label text-right">Company</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <div class="input-group">
                            <select #companyId
                              class="form-select"
                              name="companyId-field"
                              id="companyId-field"
                              formControlName="companyId"
                              (change)="companySelectDropDownChange($event)"
                              [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['companyId'].errors }"
                            >
                              <option selected></option>
                              @for (object of getDropdownDataObjectArray_Company(); track object.id) {
                                <option [ngValue]="object.id">{{object.companyName}}</option>    
                              }
                            </select>
                            <button class="btn btn-success" type="button" [disabled]="isViewCompanyLoading" (click)="viewCompany()">View</button>
                          </div>
                          <div class="invalid-feedback">A value is required</div>
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                           <label for="companyIdInput-field" class="form-label">Company</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          @if(companyId.options.selectedIndex != undefined) {
                            <a [class.disabled]="isViewCompanyLoading" (click)="viewCompany()">
                              <input
                                autocomplete="no-fill"
                                class="form-control text-end border-0"
                                id="companyIdInput-field" 
                                placeholder=""
                                [ngClass]="{ 'text-secondary': true }"
                                readonly
                                style="cursor: pointer"
                                type="text"
                                [value]="companyId.options[companyId.options.selectedIndex].text"
                              />
                            </a>
                           } @else {
                             <input autocomplete="no-fill" type="text" readonly id="companyIdInput-field" class="form-control text-end border-0" placeholder="" />
                           }
                         </div>
                       </div>
                     </div>

                     <div class="row" hidden="true">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="userId-field" class="form-label text-right">User</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <div class="input-group">
                            <select #userId
                              class="form-select"
                              name="userId-field"
                              id="userId-field"
                              formControlName="userId"
                              (change)="userSelectDropDownChange($event)"
                              [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['userId'].errors }"
                            >
                              <option selected></option>
                              @for (object of getDropdownDataObjectArray("userId"); track object.id) {
                                <option [ngValue]="object.id">{{object.description}}</option>    
                              }
                            </select>
                            <button class="btn btn-success" type="button" (click)="viewUser()">View</button>
                          </div>
                          <div class="invalid-feedback">A value is required</div>
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                           <label for="userIdInput-field" class="form-label">{{fieldAliasUsername}}</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          @if (userId.options.selectedIndex != undefined && userId.options[userId.options.selectedIndex] != undefined) {
                            <a (click)="viewUser()">
                              <input
                                autocomplete="no-fill"
                                class="form-control text-end border-0"
                                id="userIdInput-field" 
                                placeholder=""
                                [ngClass]="{ 'text-secondary': true }"
                                readonly
                                style="cursor: pointer"
                                type="text"
                                [value]="userId.options[userId.options.selectedIndex].text"
                              />
                            </a>
                           } @else {
                             <input autocomplete="no-fill" type="text" readonly id="userIdInput-field" class="form-control text-end border-0" placeholder="" />
                           }
                         </div>
                       </div>
                     </div> 
                                                                                           
                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="email-field" class="form-label">Email</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="email-field" class="form-control text-end border-0" placeholder="" formControlName="email" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['email'].errors }" />
                          @if(formOfOrderDetails['email'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{emailMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="mobileNumber-field" class="form-label">Mobile</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="mobileNumber-field" class="form-control text-end border-0" placeholder="" formControlName="mobileNumber" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['mobileNumber'].errors }" />
                          @if(formOfOrderDetails['mobileNumber'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{mobileNumberMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                         </div>
                       </div>
                     </div>

                     <div class="row">
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <label for="deviceTag-field" class="form-label">SIM Ref</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-1 px-2">
                          <input autocomplete="no-fill" type="text" id="deviceTag-field" class="form-control text-end" placeholder="" formControlName="deviceTag" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['deviceTag'].errors }" />
                          @if(formOfOrderDetails['deviceTag'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{deviceTagMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                         </div>
                       </div>
                     </div>

                     <div class="row align-items-start">
                       <div class="col-3">
                         <div class="mb-0 px-2">
                          <label for="productId-field" class="form-label text-right">Product</label>
                         </div>
                       </div>
                       <div class="col-9">
                         <div class="mb-0 px-2">
                           <select
                             class="form-select text-right"
                             name="productId-field"
                             id="productId-field"
                             formControlName="productId"
                             (change)="productSelectDropDownChange($event)"
                             [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['productId'].errors }"
                           >
                             <option selected></option>
                             @for (object of getDropdownDataObjectArray("productId"); track object.id) {
                               <option [ngValue]="object.id">{{object.description}}</option>    
                             }
                           </select>
                           @if (productChanged && currProduct?.description != undefined) {
                             <div id="productIdHint" class="form-text text-end mb-0">Previous Product <span class="text-success">{{currProduct?.description}}</span></div>
                           } 
                           @else {
                            <div class="row">       
                              <div class="col-12 mb-0 px-4">
                                <div id="productIdHint" class="form-text mb-0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                              </div>
                            </div>
                           }
                           <div class="invalid-feedback">A value is required</div>
                         </div>
                       </div>
                     </div>
                   </div>

                </div>
                <div class="col-6">

                  <div class="border border-success rounded h-100">
                    <div class="row">
                      <div class="col-12">
                        <div>
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>Live Data @if(liveDataFetched && (!sureSimLiveData?.Vendor && !sureSimLiveData?.PDP)) {<span style="color: #db2e46"> - No recent data</span>}</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveVendor-field" class="form-label">Vendor</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveVendor-field" class="form-control text-end border-0" placeholder="" formControlName="liveVendor" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveModel-field" class="form-label">Model</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveModel-field" class="form-control text-end border-0" placeholder="" formControlName="liveModel" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveCountry-field" class="form-label">Country</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveCountry-field" class="form-control text-end border-0" placeholder="" formControlName="liveCountry" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveVplmn-field" class="form-label">VPLMN</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveVplmn-field" class="form-control text-end border-0" placeholder="" formControlName="liveVplmn" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveMccminc-field" class="form-label">MCCMINC</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveMccminc-field" class="form-control text-end border-0" placeholder="" formControlName="liveMccminc" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveApn-field" class="form-label">APN</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveApn-field" class="form-control text-end border-0" placeholder="" formControlName="liveApn" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveIccid-field" class="form-label">ICCID</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveIccid-field" class="form-control text-end border-0" placeholder="" formControlName="liveIccid" />
                        </div>
                      </div>
                    </div>    

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveImei-field" class="form-label">IMEI</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          @if (showImeiLocking && isPhysicalSim && sureSimOrder?.imeiLocking != "" && sureSimOrder?.imeiLocking != undefined) {
                            <div class="input-group">
                              <input autocomplete="no-fill" type="text" readonly id="liveImei-field" class="form-control text-end border-0" placeholder="" formControlName="liveImei" style="padding-right: 0px;" />
                                <i
                                [ngClass]="{ 'bi bi-lock': !sureSimLiveData?.ImeiLockBreached, 'ri-alert-fill': sureSimLiveData?.ImeiLockBreached }"
                                [ngStyle]="{ color: sureSimLiveData?.ImeiLockBreached ? 'red' : 'green', 'padding-top': sureSimLiveData?.ImeiLockBreached ? '7px' : '6px' }"
                                [ngbTooltip]="!sureSimLiveData?.ImeiLockBreached ? 'IMEI Lock match' : 'IMEI lock does not match'"
                                ></i>
                            </div>
                          } @else {
                            <input autocomplete="no-fill" type="text" readonly id="liveImei-field" class="form-control text-end border-0" placeholder="" formControlName="liveImei" />
                          }
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="liveIp-field" class="form-label">IP</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="liveIp-field" class="form-control text-end border-0" placeholder="" formControlName="liveIp" />
                        </div>
                      </div>
                    </div> 

                    <div class="row">
                      <div class="col-6">
                        <div class="mb-2 px-2">
                          <label for="livePdp-field" class="form-label">Last Data Session Start Time (PDP)</label>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="mb-2 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="livePdp-field" class="form-control text-end border-0" placeholder="" formControlName="livePdp" />
                        </div>
                      </div>
                    </div> 

                  </div>
                </div>
              </div>
              
              <label class="form-label text-right"></label>

              <div class="row">
                <div class="col-6">
                                                                     
                  <div class="border border-success rounded h-100">
                    <div class="row">
                      <div class="col-12">
                        <div>
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>SIM Details</strong>
                          </div>
                        </div>
                      </div>
                    </div> 
                                                                                                         
                    <!-- <div class="row" hidden="true">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="statusId-field" class="form-label">Status</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <select #statusId
                            class="form-select text-right"
                            name="statusId-field"
                            id="statusId-field"
                            formControlName="statusId"
                            [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['statusId'].errors }"
                          >
                            <option selected></option>
                            @for (object of getDropdownDataObjectArray("statusId"); track object.id) {
                              <option [ngValue]="object.id">{{object.description}}</option>    
                            }
                          </select>
                          <div class="invalid-feedback">A value is required</div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-1 px-2">
                          <label for="statusIdInput-field" class="form-label">Status</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-1 px-2">
                          
                          <div class="input-group">
                            @if(statusId.options != undefined && statusId.options[statusId.options.selectedIndex] != undefined) {
                              <input autocomplete="no-fill" type="text" readonly id="statusIdInput-field" class="form-control text-end border-0" placeholder="" [value]="statusId.options[statusId.options.selectedIndex].text" />
                            } @else {
                              <input autocomplete="no-fill" type="text" readonly id="statusIdInput-field" class="form-control text-end border-0" placeholder="" />
                            }
                            <button class="btn btn-danger" type="button" (click)="suspend()">Suspend</button>
                          </div>
                         
                          @if(statusId.options != undefined && statusId.options[statusId.options.selectedIndex] != undefined) {
                            <input autocomplete="no-fill" type="text" readonly id="statusIdInput-field" class="form-control text-end border-0" placeholder="" [value]="statusId.options[statusId.options.selectedIndex].text" />
                          } @else {
                            <input autocomplete="no-fill" type="text" readonly id="statusIdInput-field" class="form-control text-end border-0" placeholder="" />
                          }
                        </div>
                      </div>
                    </div>  -->

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="status-field" class="form-label">Status</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          @if (getSimStatus(); as simStatus) {
                            <div id="status-field" class="form-control text-end border-0">
                              @if (simStatus.iconClass != "") {
                                <i class="{{simStatus.iconClass}} {{simStatus.colourClass}} cell-icon align-middle me-1"></i>
                              }
                              <span class="align-middle">{{simStatus.statusDisplay}}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="row" hidden="true">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="deviceTypeId-field" class="form-label">SIM Type</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <select #deviceTypeId
                            autocomplete="no-fill"
                            class="form-select text-right"
                            name="deviceTypeId-field"
                            id="deviceTypeId-field"
                            formControlName="deviceTypeId"
                            [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['deviceTypeId'].errors }"
                          >
                            <option selected></option>
                            @for (object of getDropdownDataObjectArray("deviceTypeId"); track object.id) {
                              <option [ngValue]="object.id">{{object.description}}</option>    
                            }
                          </select>
                          <div class="invalid-feedback">A value is required</div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="deviceTypeIdInput-field" class="form-label">SIM Type</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          @if(deviceTypeId.options != undefined && deviceTypeId.options[deviceTypeId.options.selectedIndex] != undefined) {
                            <input autocomplete="no-fill" type="text" readonly id="deviceTypeIdInput-field" class="form-control text-end border-0" placeholder="" [value]="deviceTypeId.options[deviceTypeId.options.selectedIndex].text" />
                          } @else {
                            <input autocomplete="no-fill" type="text" readonly id="deviceTypeIdInput-field" class="form-control text-end border-0" placeholder="" />
                          }
                        </div>
                      </div>
                    </div> 

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-0 px-2">
                          <label for="msisdn-field" class="form-label">MSISDN</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-0 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="msisdn-field" class="form-control text-end border-0" placeholder="" formControlName="msisdn" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['msisdn'].errors }" />
                          @if(formOfOrderDetails['msisdn'].hasError('maxlength')) {
                            <div class="invalid-feedback">Maximum length of {{msisdnMaxLength}} characters has been exceeded</div>
                          } @else {
                            <div class="invalid-feedback">A value is required</div>
                          }
                        </div>
                      </div>
                    </div>

                    @if (isPhysicalSim)
                    {
                      <div class="row">
                        <div class="col-3">
                          <div class="mb-0 px-2">
                            <label for="imeiLocking-field" class="form-label">IMEI Lock</label>
                          </div>
                        </div>
                        @if (showImeiLocking) {
                          <div class="col-9">
                            <div class="mb-0 px-2">
                              <div class="input-group">
                                <button
                                    class="btn btn-success"
                                    [disabled]="formIsLocked || ceased || simOpertationInProgress"
                                    id="vatno-field"
                                    style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;"
                                    type="button"
                                    (click)="imeiLocking()"
                                >
                                  Settings
                                </button>
                                <input autocomplete="no-fill" type="text" readonly id="imeiLocking-field" class="form-control text-end" placeholder="Off" formControlName="imeiLocking" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['imeiLocking'].errors }" />
                                <div class="invalid-feedback">A value is required</div>
                              </div>
                            </div>
                          </div>
                        } @else {
                          <div class="col-9">
                            <div class="mb-0 px-2">
                              <input autocomplete="no-fill" type="text" readonly id="imeiLocking-field" class="form-control text-end border-0" placeholder="Off" formControlName="imeiLocking" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['imeiLocking'].errors }" />
                              <div class="invalid-feedback">A value is required</div>
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="row">
                        <div class="col-3">
                          <div class="mb-0 px-2">
                            <label for="eid-field" class="form-label">EID</label>
                          </div>
                        </div>
                        @if (showRedeploy) {
                          <div class="col-9">
                            <div class="mb-0 px-2">
                              <div class="input-group">
                                <button
                                    class="btn btn-success"
                                    [disabled]="formIsLocked || ceased || simOpertationInProgress"
                                    id="vatno-field"
                                    style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;"
                                    type="button"
                                    (click)="redeploy()"
                                >
                                  Redeploy
                                </button>
                                <input autocomplete="no-fill" type="text" readonly id="eid-field" class="form-control text-end" placeholder="" formControlName="eid" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['eid'].errors }" />
                                <div class="invalid-feedback">A value is required</div>
                              </div>
                            </div>
                          </div>
                        } @else {
                          <div class="col-9">
                            <div class="mb-0 px-2">
                              <input autocomplete="no-fill" type="text" readonly id="eid-field" class="form-control text-end border-0" placeholder="" formControlName="eid" [ngClass]="{ 'is-invalid': eSimManagerFormSubmitted && formOfOrderDetails['eid'].errors }" />
                              <div class="invalid-feedback">A value is required</div>
                            </div>
                          </div>
                        }
                      </div>
                    }

                    <div class="row">
                      <div class="col-3">
                        <div class="mb-2 px-2">
                          <label for="provisionedDate-field" class="form-label">Provisioned</label>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="mb-2 px-2">
                          <input autocomplete="no-fill" type="text" readonly id="provisionedDate-field" class="form-control text-end border-0" placeholder="" formControlName="provisionedDate" />
                        </div>
                      </div>
                    </div>
                                             
                  </div>
                </div>
                <div class="col-6">

                  @if(showExclusionProfiles) {
                    <div class="row mb-3">
                      <div class="col-12">
                        <div class="border border-success rounded">
                          <div class="row">
                            <div class="col-12">
                              <div>
                                <div class="alert border-0 alert-primary" role="alert">
                                  <strong>Exclusion Profiles</strong>
                                </div>
                              </div>
                            </div>
                          </div>
      
                          <div class="row">
                            <div class="col-3">
                              <div class="mb-1 px-2">
                                <label for="exclusionProfiles-field" class="form-label">Profiles</label>
                              </div>
                            </div>
                            <div class="col-9">
                              <div class="mb-3 px-2">
                                <div class="input-group">
                                  <input autocomplete="no-fill" type="text" id="exclusionProfiles-field" class="form-control text-end" placeholder="" formControlName="exclusionProfiles" />
                                  <button class="btn btn-success" type="button" (click)="setExclusionProfiles()">Set</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if (manageEsimVersion2) {
                    <div class="row h-100">
                      <div class="col-12 h-100">
                        <div class="border border-success rounded h-100">
                          <div class="row">
                            <div class="col-12">
                              <div>
                                <div class="alert border-0 alert-primary" role="alert">
                                  <strong>SIM Operations</strong>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                              <div class="row">
                                <div class="col-12" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1rem;">
                                  <div class="mb-0 px-2 flex-shrink-0">
                                    <div class="form-check form-switch mb-0 ps-0">
                                      <input
                                        class="form-check-input ms-0"
                                        type="checkbox"
                                        role="switch"
                                        id="suspended-field"
                                        formControlName="suspended"
                                        style="width: 2.75rem; height: 1.5rem;"
                                        (click)="onSuspendedCheckboxChange($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="mb-0 px-2 d-flex align-items-center">
                                    <label class="form-check-label mb-0" for="suspended-field">Suspend</label>
                                    <i
                                      title="This stops the sim from being used until suspend is turned off again.&#10;This does not get removed at the start of next month."
                                      class="bi bi-info-circle text-secondary ms-1"
                                      style="cursor: pointer;"
                                    >
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                              <div class="row">
                                <div class="col-12" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1rem;">
                                  <div class="mb-0 px-2 flex-shrink-0">
                                    <div class="form-check form-switch mb-0 ps-0">
                                      <input
                                        class="form-check-input ms-0"
                                        type="checkbox"
                                        role="switch"
                                        id="barred-field"
                                        formControlName="barred"
                                        style="width: 2.75rem; height: 1.5rem;"
                                        (click)="onBarredCheckboxChange($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="mb-0 px-2 d-flex align-items-center">
                                    <label class="form-check-label mb-0 text-nowrap" for="barred-field">Temporary Bar (Until Month End)</label>
                                    @if (this.sureSimOrder != undefined && this.sureSimOrder.orderSpendDTO.cost > this.sureSimOrder.orderSpendDTO.usageLimit) {
                                      <i
                                        title="Turning off barring when they have exceeded their spend limit will result in them getting rebarred when they next use their sim.&#10;To stop this from occuring increase their spend limit before turning off barring.&#10;This will be removed at the start of next month."
                                        class="bi bi-info-circle text-secondary ms-1"
                                        style="cursor: pointer;"
                                      >
                                      </i>
                                    } @else {
                                     <i
                                        title="This will be removed at the start of next month."
                                        class="bi bi-info-circle text-secondary ms-1"
                                        style="cursor: pointer;"
                                      >
                                      </i>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                              <div class="row">
                                <div class="col-12" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1rem;">
                                  <div class="mb-0 px-2 flex-shrink-0">
                                    <div class="form-check form-switch mb-0 ps-0">
                                      <input
                                        class="form-check-input ms-0"
                                        type="checkbox"
                                        role="switch"
                                        id="throttled64-field"
                                        formControlName="throttled64"
                                        style="width: 2.75rem; height: 1.5rem;"
                                        (click)="onThrottled64CheckboxChange($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="mb-0 px-2 d-flex align-items-center">
                                    <label class="form-check-label mb-0" for="throttled64-field">Throttle 64Kbps</label>
                                    <i
                                      title="Only available if sim is not barred.&#10;This will be removed at the start of next month."
                                      class="bi bi-info-circle text-secondary ms-1"
                                      style="cursor: pointer;"
                                    >
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                              <div class="row">
                                <div class="col-12" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1rem;">
                                  <div class="mb-0 px-2 flex-shrink-0">
                                    <div class="form-check form-switch mb-0 ps-0">
                                      <input
                                        class="form-check-input ms-0"
                                        type="checkbox"
                                        role="switch"
                                        id="throttled512-field"
                                        formControlName="throttled512"
                                        style="width: 2.75rem; height: 1.5rem;"
                                        (click)="onThrottled512CheckboxChange($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="mb-0 px-2 d-flex align-items-center">
                                    <label class="form-check-label mb-0" for="throttled512-field">Throttle 512Kbps</label>
                                    <i
                                      title="Only available if sim is not barred.&#10;This will be removed at the start of next month."
                                      class="bi bi-info-circle text-secondary ms-1"
                                      style="cursor: pointer;"
                                    >
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          @if (showNetworkReset) {
                            <div class="row">
                              <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                                <div class="row">
                                  <div class="col-12" style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1rem;">
                                    <div class="mb-0 px-2 flex-shrink-0">
                                      <button
                                        type="button"
                                        class="btn btn-success btn-sm rounded-pill d-flex align-items-center justify-content-center"
                                        style="width: 2.75rem; height: 1.5rem; padding: 0; margin-top: 2px;"
                                        [disabled]="formIsLocked || ceased || simOpertationInProgress"
                                        id="reset-network-field"
                                        title="Reset Network"
                                        (click)="resetNetwork()"
                                      >
                                        <i class="bi bi-arrow-clockwise"></i>
                                      </button>
                                    </div>
                                    <div class="mb-0 px-2 d-flex align-items-center">
                                      <label class="form-check-label mb-0" for="reset-network-field">Reset Network</label>
                                      <i
                                        title="Forces the device to disconnect from the network and rescan for networks to connect to"
                                        class="bi bi-info-circle text-secondary ms-1"
                                        style="cursor: pointer;"
                                      >
                                      </i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }

                          @if (limitExceeded) {
                            <div class="row">
                              <div class="col-12 mb-1 px-4">
                                <div id="limitExceededHint" class="form-text text-center"><span class="text-danger">&nbsp;&nbsp;&nbsp;{{limitExceededText}}</span></div>
                              </div>
                            </div>
                          } @else {
                            <div class="row">       
                              <div class="col-12 mb-1 px-4">
                                <div id="limitHint" class="form-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                              </div>
                            </div>
                          }

                          <!-- @if (this.alertProduct == "") {
                            <div class="row">       
                              <div class="col-12 mb-1 px-4">
                                <div id="alertProductHint" class="form-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                              </div>
                            </div>
                          } -->

                          <!-- <div class="row">       
                            <div class="col-8 mb-1 px-3">
                              <div class="hstack gap-2 justify-content-start">
                                <button
                                  class="btn btn-success"
                                  [disabled]="ceased || simOpertationInProgress"
                                  id="changeLimit-field"
                                  type="button"
                                  (click)="changeLimit()"
                                >
                                  Change Spend Limits
                                </button>
  
                                <button
                                  class="btn btn-success"
                                  [disabled]="ceased || alertProduct=='' || simOpertationInProgress"
                                  id="alertProduct-field"
                                  type="button"
                                  (click)="removeAlertProduct()"
                                >
                                  Remove Alert Product
                                </button>
                                <i
                                  title="Reverts the connection to the assigned product, where an alert action has changed the product.&#10;The alert product is removed at the start of next month."
                                  class="bi bi-info-circle text-secondary ms-1"
                                  style="cursor: pointer;"
                                >
                                </i>
                              </div>
                            </div>

                            <div class="col-4 mb-1 px-3">
                              <div class="hstack gap-2 justify-content-end"> 
                                <button
                                  class="btn btn-danger"
                                  [disabled]="deprovisioned || simOpertationInProgress"
                                  id="deprovision-field"
                                  type="button"
                                  (click)="deprovisionSim()"
                                >
                                  Deprovision Sim
                                </button>
                              </div>
                            </div>
                          </div> -->
     
                          <div class="row mt-3">
                            <div class="col-1"></div>
                            <div class="col-10 d-flex justify-content-center padding-5">
                              <button
                                class="btn btn-success"
                                [disabled]="formIsLocked || ceased || simOpertationInProgress"
                                id="vatno-field"
                                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;"
                                type="button"
                                (click)="openMoreForm()"
                              >
                                Change Spend Limits, Remove Alert Product & Cease
                              </button>
                            </div>
                            <div class="col-1"></div>
                          </div>

                          @if (this.alertProduct != "") {
                            <div class="row">       
                              <div class="col-12 mb-4 px-4">
                                <div id="alertProductHint" class="form-text text-center" style="padding-bottom: 2px;">Active Alert Product <span class="text-success">{{this.alertProduct}}</span></div>
                              </div>
                            </div>
                          } @else {
                            <div class="row">       
                              <div class="col-12 mb-4 px-4">
                                <div id="alertProductHint" class="form-text" style="padding-bottom: 2px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                              </div>
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  }

                </div>
              </div>
              
              <!--
              <div class="row">
                <div class="col-12">
                  <div class="form-check form-switch form-switch-md">
                    <label class="form-check-label" for="active-field">Active</label>
                    <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active" checked>
                  </div>
                </div>
              </div>
              -->
            </div>
          </ng-template>
        </li>
        
        <li [ngbNavItem]="navItemUsageData">
          <a ngbNavLink>
            @if(showOrderTabIcons) {
              <span class="d-block"><i class="ri-battery-low-line"></i></span>
            }
            <span class="d-sm-block">Usage Data</span>
          </a>
          <ng-template ngbNavContent>
            <div formGroupName="usageDetailsForm">
              @if(newOrder){
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                      <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                      <span [innerHtml]="progressInformation"></span>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div class="row">
                <div class="col-6">

                  <div class="border border-success rounded h-100">
                    <div class="row">
                       <div class="col-12">
                         <div>
                           <div class="alert border-0 alert-primary" role="alert">
                             <strong>Current Usage @if(!sureSimLiveData) {<span style="color: #db2e46"> - No supplier data available</span>}</strong>
                           </div>
                         </div>
                       </div>
                     </div>
                     
                     <div class="row">
                       <div class="col-6">
                         <div class="mb-1 px-2">
                           <label for="currentMonthUsage-field" class="form-label">Current Month</label>
                         </div>
                       </div>
                       <div class="col-3">
                         <div class="mb-1 px-2">
                          <div id="currentMonthUsageHint" class="form-text">Usage</div>
                          <input autocomplete="no-fill" type="text" readonly id="currentMonthUsage-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="currentMonthUsage" />
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="mb-1 px-2">
                         <div id="currentMonthCostHint" class="form-text">Cost</div>
                         <input autocomplete="no-fill" type="text" readonly id="currentMonthCost-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="currentMonthCost" />
                        </div>
                      </div>
                    </div>
                     
                    <div class="row">
                      <div class="col-5">
                        <div class="mb-1 px-2">
                          <label for="lastCountryUsage-field" class="form-label">Last Country</label>
                        </div>
                      </div>
                      <div class="col-7">
                        <div class="mb-1 px-2">
                          <div class="input-wrapper">
                            <input autocomplete="no-fill" type="text" readonly id="lastCountryUsage-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="lastCountryUsage" />
                            @if(formOfUsageDetails['lastCountryFlagIcon'].value != undefined && formOfUsageDetails['lastCountryFlagIcon'].value.trim() != "") {
                              <img width="16" [src]="formOfUsageDetails['lastCountryFlagIcon'].value" alt="icon" class="input-icon-right">
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                     
                    <div class="row">
                      <div class="col-6">
                        <div class="mb-1 px-2">
                          <label for="lastUsageDate-field" class="form-label">Last Usage</label>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="mb-1 px-2">
                         @if(sureSimLiveData) {
                           <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="lastUsageDate" />
                         } @else {
                          <input type="datetime" readonly id="lastUsageDate-field" class="form-control text-end border-0 text-bg-light" placeholder="" />
                         }
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="mb-2 px-2">
                          <label for="dummy-spacer2-field" class="form-label"></label>
                        </div>
                      </div>
                    </div>
                    
                  </div>

                </div>
                <div class="col-6">

                  <div class="border border-success rounded h-100">
                    <div class="row">
                      <div class="col-12">
                        <div>
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>{{limitSectionTitle}}</strong>
                            <span class="position-absolute top-50 end-0 translate-middle-y px-2">
                              <button class="btn btn-success" [disabled]="formIsLocked" type="button" (click)="manageUsage()">
                                Manage
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    @if (currentLimitType === LimitType.Spend) {
                      <div class="row">
                        <div class="col-9">
                          <div class="mb-2 px-2">
                           <strong [attr.title]="showHintSpendLimit ? null : hintSpendLimit">
                             {{textSpendLimit}}
                             <i *ngIf="!showHintSpendLimit"
                               [attr.title]="showHintSpendLimit ? null : hintSpendLimit"
                               class="bi bi-info-circle text-secondary ms-1"
                               style="cursor: pointer;"
                             >
                             </i>
                           </strong>
                           <div *ngIf="showHintSpendLimit" class="text-primary small">
                             {{hintSpendLimit}}
                           </div>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-1 px-2">
                           <input autocomplete="no-fill" type="text" readonly id="usageLimit-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="usageLimit" />
                           @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                             <div id="usageLimitHint" class="form-text text-end">Pending <span class="text-success">{{possibleOrderUsageLimits?.limit ?? companyUsageLimits?.limit}}</span></div>
                           }
                          </div>
                        </div>
                      </div>

                      @if(this.showSelfAuthSpendLimit) {
                        <div class="row">
                          <div class="col-9">
                            <div class="mb-2 px-2">
                             <strong [attr.title]="showHintSelfAuthSpendLimit ? null : hintSelfAuthSpendLimit">
                               {{textSelfAuthSpendLimit}}
                               <i *ngIf="!showHintSelfAuthSpendLimit"
                                 [attr.title]="showHintSelfAuthSpendLimit ? null : hintSelfAuthSpendLimit"
                                 class="bi bi-info-circle text-secondary ms-1"
                                 style="cursor: pointer;"
                               >
                               </i>
                             </strong>
                             <div *ngIf="showHintSelfAuthSpendLimit" class="text-primary small">
                               {{hintSelfAuthSpendLimit}}
                             </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="mb-1 px-2">
                              <input autocomplete="no-fill" type="text" readonly id="limitSelfAuth-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="limitSelfAuth" />
                              @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                                <div id="limitSelfAuthHint" class="form-text text-end">Pending <span class="text-success">{{possibleOrderUsageLimits?.limitSelfAuth}}</span></div>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      <div class="row">
                        <div class="col-9">
                          <div class="mb-2 px-2">
                           <strong [attr.title]="showHintCurrentSpendLimit ? null : hintCurrentSpendLimit">
                             {{textCurrentSpendLimit}}
                             <i *ngIf="!showHintCurrentSpendLimit"
                               [attr.title]="showHintCurrentSpendLimit ? null : hintCurrentSpendLimit"
                               class="bi bi-info-circle text-secondary ms-1"
                               style="cursor: pointer;"
                             >
                             </i>
                           </strong>
                           <div *ngIf="showHintCurrentSpendLimit" class="text-primary small">
                             {{hintCurrentSpendLimit}}
                           </div>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-1 px-2">
                           <input autocomplete="no-fill" type="text" readonly id="limitCurrent-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="limitCurrent" />
                           @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                             <div id="limitCurrentHint" class="form-text text-end">Pending <span class="text-success">{{possibleOrderUsageLimits?.limitCurrent ?? possibleOrderUsageLimits?.limit ?? companyUsageLimits?.limit}}</span></div>
                           }
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-9">
                          <div class="mb-1 px-2">
                            <label for="usageLimitUsedPercent-field" class="form-label">Used</label>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-3 px-2">
                           <input autocomplete="no-fill" type="text" readonly id="usageLimitUsedPercent-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="usageLimitUsedPercent" />
                          </div>
                        </div>
                      </div>
                    }

                    @if (currentLimitType === LimitType.Data) {
                      <div class="row">
                        <div class="col-9">
                          <div class="mb-2 px-2">
                            <strong>Data Limit</strong>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-1 px-2">
                            <input autocomplete="no-fill" type="text" readonly id="dataLimit-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="dataLimit" />
                            @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                              <div id="dataLimitHint" class="form-text text-end">Pending <span class="text-success">{{possibleOrderUsageLimits?.dataLimit ?? companyUsageLimits?.dataLimit}} {{possibleOrderUsageLimits?.dataLimitDataWeightCode ?? companyUsageLimits?.dataLimitDataWeightCode ?? 'MB'}}</span></div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-9">
                          <div class="mb-2 px-2">
                            <strong>Current Month</strong>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-1 px-2">
                            <input autocomplete="no-fill" type="text" readonly id="dataLimitCurrent-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="dataLimitCurrent" />
                            @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                              <div id="dataLimitCurrentHint" class="form-text text-end">Pending <span class="text-success">{{possibleOrderUsageLimits?.dataLimitCurrent ?? possibleOrderUsageLimits?.dataLimit ?? companyUsageLimits?.dataLimit}} {{possibleOrderUsageLimits?.dataLimitCurrentDataWeightCode ?? possibleOrderUsageLimits?.dataLimitDataWeightCode ?? companyUsageLimits?.dataLimitDataWeightCode ?? 'MB'}}</span></div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-9">
                          <div class="mb-1 px-2">
                            <label for="dataLimitUsedPercent-field" class="form-label">Used</label>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="mb-3 px-2">
                            <input autocomplete="no-fill" type="text" readonly id="dataLimitUsedPercent-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="dataLimitUsedPercent" />
                          </div>
                        </div>
                      </div>
                    }

                    @if (currentLimitType === LimitType.Off) {
                      <div class="row">
                        <div class="col-9">
                          <div class="mb-3 px-2">
                            @if (usageLimitsChanged && !pendingLimitTypeChanged) {
                              <div class="form-text">Pending</div>
                            } @else {
                              &nbsp;
                            }
                          </div>
                        </div>
                      </div>
                    }

                    @if (pendingLimitTypeChanged) {
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-2 px-2">
                            <div class="form-text">Pending change to <span class="text-success fw-semibold">{{pendingLimitTypeName}}</span></div>
                          </div>
                        </div>
                      </div>

                      @if (possibleOrderUsageLimits?.limitType === LimitType.Spend) {
                        <div class="row">
                          <div class="col-9">
                            <div class="mb-1 px-2"><strong>{{textSpendLimit}}</strong></div>
                          </div>
                          <div class="col-3">
                            <div class="mb-1 px-2 text-end">
                              <span class="text-success">{{companyCurrencySymbol}}{{possibleOrderUsageLimits?.limit ?? companyUsageLimits?.limit}}</span>
                            </div>
                          </div>
                        </div>
                        @if (showSelfAuthSpendLimit) {
                          <div class="row">
                            <div class="col-9">
                              <div class="mb-1 px-2"><strong>{{textSelfAuthSpendLimit}}</strong></div>
                            </div>
                            <div class="col-3">
                              <div class="mb-1 px-2 text-end">
                                <span class="text-success">{{companyCurrencySymbol}}{{possibleOrderUsageLimits?.limitSelfAuth}}</span>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="row">
                          <div class="col-9">
                            <div class="mb-3 px-2"><strong>{{textCurrentSpendLimit}}</strong></div>
                          </div>
                          <div class="col-3">
                            <div class="mb-3 px-2 text-end">
                              <span class="text-success">{{companyCurrencySymbol}}{{possibleOrderUsageLimits?.limitCurrent ?? possibleOrderUsageLimits?.limit ?? companyUsageLimits?.limit}}</span>
                            </div>
                          </div>
                        </div>
                      }

                      @if (possibleOrderUsageLimits?.limitType === LimitType.Data) {
                        <div class="row">
                          <div class="col-9">
                            <div class="mb-1 px-2"><strong>Data Limit</strong></div>
                          </div>
                          <div class="col-3">
                            <div class="mb-1 px-2 text-end">
                              <span class="text-success">{{possibleOrderUsageLimits?.dataLimit ?? companyUsageLimits?.dataLimit}} {{possibleOrderUsageLimits?.dataLimitDataWeightCode ?? companyUsageLimits?.dataLimitDataWeightCode ?? 'MB'}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-9">
                            <div class="mb-3 px-2"><strong>Current Month</strong></div>
                          </div>
                          <div class="col-3">
                            <div class="mb-3 px-2 text-end">
                              <span class="text-success">{{possibleOrderUsageLimits?.dataLimitCurrent ?? possibleOrderUsageLimits?.dataLimit ?? companyUsageLimits?.dataLimit}} {{possibleOrderUsageLimits?.dataLimitCurrentDataWeightCode ?? possibleOrderUsageLimits?.dataLimitDataWeightCode ?? companyUsageLimits?.dataLimitDataWeightCode ?? 'MB'}}</span>
                            </div>
                          </div>
                        </div>
                      }
                    }

                  </div>
                </div>
              </div>
              
              <label class="form-label text-right"></label>

              <div class="row">
                <div class="col-6">
                  
                  <div [class.d-none]="!gotIccid">
                    <app-chart-costs-per-day #chartCostsPerDay
                      [chartHeight]="250"
                      [evenDaysOnly]="true"
                    ></app-chart-costs-per-day>
                  </div>
                  
                </div>
                <div class="col-6">
                  <div [class.d-none]="!gotIccid">
                    <app-chart-usage-per-day #chartUsagePerDay
                      [chartHeight]="250"
                      [evenDaysOnly]="true"
                    ></app-chart-usage-per-day>
                  </div>
                  <!--
                  <div class="border border-success rounded">
                    <div class="row">
                      <div class="col-12">
                        <div>
                          <div class="alert border-0 alert-primary" role="alert">
                            <strong>Usage Per Day</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="card px-2">
                          @if (iccidChartUsage != undefined) {
                            <div class="card-body">
                              <apx-chart
                                [chart]="iccidChartUsage.chart"
                                [colors]="iccidChartUsage.colors"
                                [dataLabels]="iccidChartUsage.dataLabels"
                                dir="ltr"
                                [fill]="iccidChartUsage.fill"
                                [labels]="iccidChartUsage.labels"
                                [markers]="iccidChartUsage.markers"
                                [plotOptions]="iccidChartUsage.plotOptions"
                                [series]="iccidChartUsage.series"
                                [stroke]="iccidChartUsage.stroke"
                                [title]="iccidChartUsage.title"
                                [tooltip]="iccidChartUsage.tooltip"
                                [xaxis]="iccidChartUsage.xaxis"
                                [yaxis]="iccidChartUsage.yaxis"
                              >
                              </apx-chart>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  -->
                </div>
              </div>

              @if (showApplicationUsage) {
                <label class="form-label text-right"></label>
                <div class="row">
                  <div class="col-6">
                    <div class="border border-success rounded" #applicationDayBorder>
                      <div class="row">
                        <div class="col-12">
                          <div>
                            <div class="alert border-0 alert-primary" role="alert">
                              <strong>Application Usage - Today's Top 5 @if(applicationData == undefined || applicationData.length == 0) {<span style="color: #db2e46">- No supplier data available</span>}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div
                            class="custom-col-1"
                          > <!-- [style.--donut-0-dynamic-width]="30" -->
                            <div class="card card-height-100">
                              @if(this.loadingChart) {
                                <div class="d-flex align-items-end justify-content-between mt-4 ms-4">
                                  <div>
                                    <p class="fw-medium text-muted text-truncate mb-4"><i>Loading...</i></p>
                                  </div>
                                </div>
                              } @else if (applicationDayChart != undefined && applicationData != undefined && applicationData.length > 0) {                                      
                                <!-- <div class="card-body">
                                  <apx-chart
                                    [chart]="applicationDayChart.chart"
                                    class="apex-charts"
                                    [colors]="applicationDayChart.colors" dir="ltr"
                                    [dataLabels]="applicationDayChart.dataLabels"
                                    dir="ltr"
                                    [labels]="applicationDayChart.labels"
                                    [legend]="applicationDayChart.legend"
                                    [series]="applicationDayChart.series"
                                    [stroke]="applicationDayChart.stroke"
                                    [tooltip]="applicationDayChart.tooltip"
                                  ></apx-chart>
                                </div> -->
                                <div class="card-body" style="padding-left: 10px;padding-right: 10px;">
                                  <apx-chart #applicationDayChartRef
                                    [chart]="applicationDayChart.chart"
                                    [colors]="applicationDayChart.colors"
                                    dir="ltr"
                                    [fill]="applicationDayChart.fill"
                                    [labels]="applicationDayChart.labels"
                                    [legend]="applicationDayChart.legend"
                                    [markers]="applicationDayChart.markers"
                                    [plotOptions]="applicationDayChart.plotOptions"
                                    [dataLabels]="applicationDayChart.dataLabels"
                                    [series]="applicationDayChart.series"
                                    [stroke]="applicationDayChart.stroke"
                                    [title]="applicationDayChart.title"
                                    [tooltip]="applicationDayChart.tooltip"
                                    [xaxis]="applicationDayChart.xaxis"
                                    [yaxis]="applicationDayChart.yaxis"
                                  >
                                  </apx-chart>
                                </div>  
                              } @else {
                                <div class="card-body">
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-6">
                    <div class="border border-success rounded" #applicationMonthBorder>
                      <div class="row">
                        <div class="col-12">
                          <div>
                            <div class="alert border-0 alert-primary" role="alert">
                              <strong>Application Usage - Current Month's Top 5 @if(applicationTotalData == undefined || applicationTotalData.length == 0) {<span style="color: #db2e46">- No supplier data available</span>}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div
                            class="custom-col-1"
                          > <!-- [style.--donut-0-dynamic-width]="30" -->
                            <div class="card card-height-100">
                              @if(this.loadingTotalChart) {
                                <div class="d-flex align-items-end justify-content-between mt-4 ms-4">
                                  <div>
                                    <p class="fw-medium text-muted text-truncate mb-4"><i>Loading...</i></p>
                                  </div>
                                </div>
                              } @else if (applicationMonthChart != undefined && applicationTotalData != undefined && applicationTotalData.length > 0) {    
                                <div class="card-body" style="padding-left: 10px;padding-right: 10px;">
                                  <apx-chart #applicationMonthChartRef
                                    [chart]="applicationMonthChart.chart"
                                    [colors]="applicationMonthChart.colors"
                                    dir="ltr"
                                    [fill]="applicationMonthChart.fill"
                                    [labels]="applicationMonthChart.labels"
                                    [legend]="applicationMonthChart.legend"
                                    [markers]="applicationMonthChart.markers"
                                    [plotOptions]="applicationMonthChart.plotOptions"
                                    [dataLabels]="applicationMonthChart.dataLabels"
                                    [series]="applicationMonthChart.series"
                                    [stroke]="applicationMonthChart.stroke"
                                    [title]="applicationMonthChart.title"
                                    [tooltip]="applicationMonthChart.tooltip"
                                    [xaxis]="applicationMonthChart.xaxis"
                                    [yaxis]="applicationMonthChart.yaxis"
                                  >
                                  </apx-chart>
                                </div>                                  
                                <!-- <div class="card-body">
                                  <apx-chart
                                    [chart]="applicationMonthChart.chart"
                                    class="apex-charts"
                                    [colors]="applicationMonthChart.colors" dir="ltr"
                                    [dataLabels]="applicationMonthChart.dataLabels"
                                    dir="ltr"
                                    [labels]="applicationMonthChart.labels"
                                    [legend]="applicationMonthChart.legend"
                                    [series]="applicationMonthChart.series"
                                    [stroke]="applicationMonthChart.stroke"
                                    [tooltip]="applicationMonthChart.tooltip"
                                  ></apx-chart>
                                </div> -->
                              } @else {
                                <div class="card-body">
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <label class="form-label text-right"></label>
              
              <div class="row">
                <div class="col-12">

                  @if(sureSimLiveData) {
                    <div class="border border-success rounded">
                      <div class="row">
                        <div class="col-12">
                          <div>
                            <div class="alert border-0 alert-primary" role="alert">
                              <strong>Last Data Sessions</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="px-2">
                        <app-sim-data-sessions-embedded
                          [orderID]="sureSimOrderId"
                        ></app-sim-data-sessions-embedded>
                      </div>
                    </div>
                  }

                </div>
              </div>

            </div>
          </ng-template>
        </li>
  
        <li [ngbNavItem]="navItemNetworkEvents">
          <a ngbNavLink>
            @if(showOrderTabIcons) {
              <span class="d-block"><i class="ri-signal-tower-line"></i></span>
            }
            <span class="d-sm-block">Network Events</span>
          </a>
          <ng-template ngbNavContent>
            <app-sim-network-events-embedded
              [iccid]="iccidForEmbeddedPages"
              [locationLicensed]="showLocationServices"
              [orderid]="sureSimOrderId"
            >
            </app-sim-network-events-embedded>
          </ng-template>
        </li>
  
        <li [ngbNavItem]="navItemLogs">
          <a ngbNavLink>
            @if(showOrderTabIcons) {
              <span class="d-block"><i class="ri-file-list-3-line"></i></span>
            }
            <span class="d-sm-block">Logs</span>
          </a>
          <ng-template ngbNavContent>

            <ul ngbNav #ArrowNgbNav_Log="ngbNav" [(activeId)]="activeIdLogs" class="nav nav-pills arrow-navtabs nav-success bg-light mb-3">
  
              <li [ngbNavItem]="navItemLog_ProductChange">
                <a ngbNavLink>
                  @if(showOrderLogTabIcons) {
                    <span class="d-block"><i class="ri-file-list-line"></i></span>
                  }
                  <span class="d-sm-block">Product Change</span>
                </a>
                <ng-template ngbNavContent>
                  <app-sim-product-change-log-embedded
                    [iccid]="iccidForEmbeddedPages"
                    [orderNo]="orderNoForEmbeddedPages"
                  >
                  </app-sim-product-change-log-embedded>
                </ng-template>
              </li>
              
              <li [ngbNavItem]="navItemLog_eSIM">
                <a ngbNavLink>
                  @if(showOrderLogTabIcons) {
                    <span class="d-block"><i class="ri-file-list-line"></i></span>
                  }
                  <span class="d-sm-block">SIM</span>
                </a>
                <ng-template ngbNavContent>
                  <div formGroupName="logsEsimForm">
                    <div class="row">
                      <div class="mb-3">
                      <div class="col-6">
                        <div class="border border-success rounded">
                                                         
                          <div class="row">
                            <div class="col-12">
                              <div>
                                <div class="alert border-0 alert-primary" role="alert">
                                  <strong>SIM Profile</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                                                         
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="eid-field" class="form-label">EID</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <input autocomplete="no-fill" type="text" readonly id="eid-field" class="form-control text-end border-0" placeholder="" formControlName="eid" />
                              </div>
                            </div>
                          </div>
                                                            
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="account-field" class="form-label">{{fieldAliasUsername}}</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <a (click)="viewUser()">
                                  <input
                                    autocomplete="no-fill"
                                    class="form-control text-end border-0"
                                    formControlName="account"
                                    id="account-field" 
                                    placeholder=""
                                    [ngClass]="{ 'text-secondary': true }"
                                    readonly
                                    style="cursor: pointer"
                                    type="text"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                                                            
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="state-field" class="form-label">State</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <input autocomplete="no-fill" type="text" readonly id="state-field" class="form-control text-end border-0" placeholder="" formControlName="state" />
                              </div>
                            </div>
                          </div>
                                                            
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="status-field" class="form-label">Status</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <input autocomplete="no-fill" type="text" readonly id="status-field" class="form-control text-end border-0" placeholder="" formControlName="status" />
                              </div>
                            </div>
                          </div>
                                                            
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="lastEventLogTimeStamp-field" class="form-label">Last Event Log Timestamp</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <input autocomplete="no-fill" type="text" readonly id="lastEventLogTimeStamp-field" class="form-control text-end border-0" placeholder="" formControlName="lastEventLogTimeStamp" />
                              </div>
                            </div>
                          </div>
                                                            
                          <div class="row">
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <label for="email-field" class="form-label">Email</label>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="mb-1 px-2">
                                <input autocomplete="no-fill" type="text" readonly id="email-field" class="form-control text-end border-0" placeholder="" formControlName="email" />
                              </div>
                            </div>
                          </div>
                                                         
                        </div>
                      </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="border border-success rounded">
                                                         
                          <div class="row">
                            <div class="col-12">
                              <div>
                                <div class="alert border-0 alert-primary" role="alert">
                                  <strong>SIM Event Log</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                                                         
                          <div class="row">
                            <div class="col-12">
                              <div class="mb-0 px-2">
                                <app-sim-esim-log-embedded
                                  [iccid]="iccidForEmbeddedPages"
                                  [orderid]="sureSimOrderId"
                                >
                                </app-sim-esim-log-embedded>
                              </div>
                            </div>
                          </div>
                                                         
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>

              <li [ngbNavItem]="navItemLog_Alerts">
                <a ngbNavLink>
                  @if(showOrderLogTabIcons) {
                    <span class="d-block"><i class="ri-alarm-warning-line"></i></span>
                  }
                  <span class="d-sm-block">Alerts</span>
                </a>
                <ng-template ngbNavContent>
                  <app-sim-alerts-log-embedded
                    [companyId]="sureSimOrder?.companyID"
                    [deviceId]="sureSimOrder?.deviceID"
                  >
                  </app-sim-alerts-log-embedded>
                </ng-template>
              </li>

              @if (curUser.systemAdmin) {
              <li [ngbNavItem]="navItemLog_Communication">
                <a ngbNavLink>
                  @if(showOrderLogTabIcons) {
                    <span class="d-block"><i class="ri-file-list-line"></i></span>
                  }
                  <span class="d-sm-block">Communication</span>
                </a>
                <ng-template ngbNavContent>
                    ...Communication Log...
                </ng-template>
              </li>
        
              <li [ngbNavItem]="navItemLog_UsageControl">
                <a ngbNavLink>
                  @if(showOrderLogTabIcons) {
                    <span class="d-block"><i class="ri-file-list-line"></i></span>
                  }
                  <span class="d-sm-block">Usage Control</span>
                </a>
                <ng-template ngbNavContent>
                    ...Usage Control Log...
                </ng-template>
              </li>
              }
            </ul>
            
            <div class="tab-content">
              <div [ngbNavOutlet]="ArrowNgbNav_Log"></div>
            </div>
          </ng-template>
        </li>
  
        @if (enableTimelineIcon) {
          <li [ngbNavItem]="navItemTimeline">
            <a ngbNavLink>
              @if(showOrderTabIcons) {
                <span class="d-block"><i class="ri-time-line"></i></span>
              }
              <span class="d-sm-block">Live View</span>
            </a>
            <ng-template ngbNavContent></ng-template>
          </li>
        }

        @if (showAlerts) {
          <li [ngbNavItem]="navItemCompanyAlerts">
            <a ngbNavLink>
              <span class="d-block"><i class="ri-alert-line"></i></span>
              <span class="d-sm-block">Alerts</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    <app-alerts-modal-form
                      [companyId]="sureSimOrder!.companyID!"
                      [deviceId]="sureSimOrder!.deviceID!"
                      [isCompany]="false"
                    ></app-alerts-modal-form>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }

        @if (showSupport) {
          <li [ngbNavItem]="navItemSupport">
            <a ngbNavLink>
              <span class="d-block"><i class="bi-ticket-perforated"></i></span>
              <span class="d-sm-block">Support</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    <app-manage-tickets
                         [companyId]="sureSimOrder?.companyID"
                         [initialInviewCompanyId]="sureSimOrder?.companyID"
                         [initialSureSimDeviceId]="sureSimDevice?.id"
                         [initialInviewUserId]="sureSimOrder?.userID"
                         [deviceId]="sureSimOrder?.deviceID"
                         [userId]="sureSimOrder?.userID"
                         [isCompany]="false"
                         [isDevice]="true"
                         [isUser]="false"
                         [matchCompanyAndUser]="false"
                         [newSim]="false"
                    ></app-manage-tickets>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
        @if (showLocationServices) {
          <li [ngbNavItem]="navItemLocationServices">
            <a ngbNavLink>
              <span class="d-block"><i class="ri-map-pin-2-line"></i></span>
              <span class="d-sm-block">Location</span>
            </a>
            <ng-template ngbNavContent>
              <div>
                <div class="row">
                  <div class="col-12">
                    <app-map-sim-locations #mapSimLocations
                      [iccid]="sureSimDevice?.imeiIccid"
                      [locationOwnerUserId]="sureSimOrder?.userID"
                      [locationCompanyId]="sureSimOrder?.companyID"
                      [wideSidebar]="true"
                      (locationSettingsChanged)="onSimLocationSettingsChanged()"
                    ></app-map-sim-locations>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        }
      </ul>
      
      <div class="tab-content">
        <div [ngbNavOutlet]="ArrowNgbNav"></div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="eSimManagerFormCancel()">Close</button>
        <button type="submit" [disabled]="invalidInputs() || formIsLocked" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>

    <app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
      [showSpinner]="this.simOperationShowSpinner"
    ></app-spinner-overlay-wrapper>

  </form>
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-imei-locking-modal-form #imeiLockEsim
  (imeiLockingCancelled)="imeiLockingCancelled()"
  (imeiLockingOrderUpdated)="imeiLockingOrderUpdated($event)"
  (imeiLockingSuccessful)="imeiLockingSuccessful()"
></app-imei-locking-modal-form>

<app-manage-esim-modal-form-more #manageEsimMore
  (moreFormCancelled)="moreFormHasBeenCancelled($event)"
  (moreFormHasBeenSaved)="moreFormHasBeenSaved()"
></app-manage-esim-modal-form-more>

<app-redeploy-modal-form #redeployEsim
  (redeployCancelled)="redeployCancelled()"
  (redeployOrderUpdated)="redeployOrderUpdated($event)"
  (redeploySuccessful)="redeploySuccessful()"
></app-redeploy-modal-form>

<app-timeline-esim-modal-form #timelineModalForm
  [disableManageSimForm]="true"
  (riskButtonClick)="riskButtonClick.emit($event)"
></app-timeline-esim-modal-form>

<app-usage-limits-modal-form #usageLimitsModalForm
  (dataHasBeenSaved)="usageLimitsModalFormSaved($event)"
  (usageLimitsFormCancelled)="usageLimitsModalFormHasBeenCancelled()"
></app-usage-limits-modal-form>

<app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="userDataHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>

<app-confirmation-modal-form #deleteSimConfirmationModal
  (modalYes)="yesDeleteSim()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #resetNetworkConfirmationModal
  (modalYes)="yesResetNetwork()"
></app-confirmation-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

